import type { SVGProps } from 'react';
const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.714 13.53h-3.428C7.814 13.53 5 16.737 5 20.696 5 21.417 5.512 22 6.143 22h13.714c.631 0 1.143-.584 1.143-1.303 0-3.959-2.814-7.168-6.286-7.168M6.75 20.044c.282-2.57 2.207-4.56 4.536-4.56h3.428c2.327 0 4.254 1.993 4.536 4.56zM13 13c2.525 0 4.571-2.015 4.571-4.5S15.525 4 13 4 8.429 6.015 8.429 8.5c0 2.486 2.046 4.5 4.571 4.5m0-7.312c1.575 0 2.857 1.261 2.857 2.812S14.575 11.313 13 11.313 10.143 10.05 10.143 8.5 11.425 5.688 13 5.688"
    />
  </svg>
);
export default SvgUser;
